import { buildFormData } from "./payload.helper";

const ALLOWED_FIELDS = [
  "patient_id",
  "attendant_id",
  "visit_date",
  "next_visit_plan",
  "is_referred",
  "referred_location",
  "remarks",
  "diagnosis",
  "prescription",
  "hospital_name",
  "first_aid_given",
  "cause_of_referral",
  "status",
];

const pickFields = (data) =>
  ALLOWED_FIELDS.reduce((acc, key) => {
    if (data[key] !== undefined) {
      acc[key] = data[key];
    }
    return acc;
  }, {});

const patientVisitsHelper = {
  forCreate: (data) => buildFormData(pickFields(data)),

  forUpdate: (id, data) => ({
    id,
    body: buildFormData(pickFields(data)),
  }),
};
export default patientVisitsHelper;